
import Dropdown from '@/ui-kit/components/dropdown';
import FilterFactory from '../factories/filter-factory';
import { StyleColorSchemeType, StyleSizeType } from '../../../ui-kit/styles/enums';
import { FilterMoreEventType, FilterMoreDefaultFilters } from './enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';

export default {
  name: 'FilterMore',
  components: {
    Dropdown,
    FilterFactory,
  },
  props: {
    className: {
      default: '',
      type: String,
    },
    value: {
      default: () => ({}),
      type: Object,
    },
    filters: {
      default: () => FilterMoreDefaultFilters,
      type: Array,
    },
    id: {
      default: '',
      type: String,
    },
    label: {
      default: 'More',
      type: String,
    },
    checkboxIconSize: {
      default: StyleSizeType.XSmall,
      type: String,
    },
    colorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    labelColorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    iconColor: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    moreClassNames() {
      return new StyleClassNamesBuilder('more')
        .addClassName(this.className)
        .build();
    },
  },
  methods: {
    handleFactoryClick({ key, value }) {
      this.$emit(FilterMoreEventType.Change, { key, value });
    },
  },
};
